/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { LayoutSlot } from '@/components/layouts/LayoutSlot';
import { layoutMainSX } from '@/components/layouts/styles/main';
import { Layout } from '@/data/types/Layout';
import { Stack } from '@mui/material';
import { FC } from 'react';

export const HomeStack: FC<{ layout: Layout }> = ({ layout }) => (
	<>
		{layout ? (
			<>
				<LayoutSlot slot={layout.slots.header} />
				<Stack
					component="main"
					gap={0}
					alignItems="center"
					sx={layoutMainSX(layout.slots.first?.length ?? 0)}
				>
					<LayoutSlot slot={layout.slots.first} />
					<LayoutSlot slot={layout.slots.second} />
					<LayoutSlot slot={layout.slots.footer} />
				</Stack>
			</>
		) : null}
	</>
);
